import {
  PolfEventModeEnum,
  PolfEventRankingEnum,
} from '@polf/shared/codegen/types'

/**
 * Norwegian short label for the eyebrow / topbar — uppercase by CSS.
 * Returned verbatim (no extra letterSpacing) so callers compose freely.
 */
export const modeEyebrow = (
  mode: PolfEventModeEnum | null | undefined
): string => {
  switch (mode) {
    case PolfEventModeEnum.Polf:
      return 'POLF'
    case PolfEventModeEnum.Golf:
      return 'Golf'
    case PolfEventModeEnum.Scramble:
      return 'Scramble'
    case PolfEventModeEnum.Bestball:
      return 'Best ball'
    case PolfEventModeEnum.Bestworst:
      return 'Best/worse'
    case PolfEventModeEnum.Foursome:
      return 'Foursome'
    case PolfEventModeEnum.Segmented:
      return '6+6+6'
    default:
      return 'POLF'
  }
}

/**
 * One ball per team: the score rows belong to the team, so the flight screen,
 * the scorecard and the profile all speak about the team rather than the
 * player — and the player's own allowance breakdown is a number nobody plays
 * off.
 */
export const isOneBallTeamMode = (
  mode: PolfEventModeEnum | null | undefined
): boolean =>
  mode === PolfEventModeEnum.Scramble || mode === PolfEventModeEnum.Foursome

/**
 * Best Worst: two pairs, a best-ball point and a worst-ball point per hole.
 * Every ball counts, so the best-ball surfaces — a team card of counting balls,
 * a contributor pill — describe a game nobody is playing here.
 */
export const isBestWorst = (
  mode: PolfEventModeEnum | null | undefined
): boolean => mode === PolfEventModeEnum.Bestworst

/**
 * One round split into equal blocks, each played in its own format.
 *
 * The flight then holds BOTH team-owned and player-owned entries at once, so
 * every surface that asks "who owns a row here" has to ask per hole rather
 * than per event.
 */
export const isSegmented = (
  mode: PolfEventModeEnum | null | undefined
): boolean => mode === PolfEventModeEnum.Segmented

/** POLF mode is the only one with the chip economy attached. */
export const usesChips = (
  mode: PolfEventModeEnum | null | undefined
): boolean => mode === PolfEventModeEnum.Polf

/** Did the event opt into net-stroke ranking? */
export const isNetStrokes = (
  ranking: PolfEventRankingEnum | null | undefined
): boolean => ranking === PolfEventRankingEnum.NetStrokes
